import {Tooltip, Typography} from "@mui/material";
import React from "react";
import {ProductCardTitleProps} from "@/types/product";


export default function ProductCardTitle({
                                             name,
                                             car,
                                             centerText = false,
                                             sx,
                                             tooltip = false,
                                             ...others
                                         }: ProductCardTitleProps) {

    return (
        <>
            {
                tooltip ?
                    <Tooltip placement = "top" title = {name + ' ' + car}
                        slotProps = {{popper: {modifiers: [{name: 'offset', options: {offset: [0, -3]}}]}}} >
                        <Typography component = 'div' sx = {{
                            mb: 0.5,
                            display: "-webkit-box",
                            fontWeight: 400,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 1,
                            wordBreak: "break-word",
                            ...sx,
                        }}
                            {...others}
                        >
                            {name + ' ' + car}
                        </Typography >
                    </Tooltip >
                    :
                    <Typography
                        component = 'div'
                        overflow = "hidden"
                        mb = {.5}
                        fontWeight = {400}
                        display="-webkit-box"
                        textOverflow="ellipsis"
                        sx = {{
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            textAlign: centerText ? "center" : "left",
                            wordBreak: "break-word",
                            ...sx,
                        }}
                        {...others}>
                        {name + ' ' + car}
                    </Typography >
            }
        </>
    )
}